import { Link } from 'react-router';
import { SanitySideItem } from '../../@types';
import { sanityImageURL } from '../../helpers/sanity';

type CMSSideItemProps = {
  item: SanitySideItem;
};

const CMSSideItem = ({ item }: CMSSideItemProps) => {
  const src = sanityImageURL(item?.image, { w: 480 });

  return (
    <Link to={item?.callToActionURL ?? '/'}>
      <img
        alt={item.title}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        src={src}
        title={item.title}
      />
    </Link>
  );
};

export default CMSSideItem;
